<template>
  <div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">À propos</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Wiki</a></li>
          <li class="langage"><a href="#">FR</a></li>
        </ul>
      </app-navigation>
    
	<app-hero-section :urlBackground="urlBackground" :herotype="herotype"></app-hero-section>	

  </header>

  <main ref="main">
    <section ref="scroll_zone" >
    <section class="
      boxed 
      pt-57 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
        <div class="color"></div>
        <div class="cover" style="background-image:url('https://images.prismic.io/monito/16e68983d8b5a2c477b6ca8c091e056af6ca6076_32493215220_47d9497750_k.jpg?auto=compress,format');"></div>
        <h1 id="anchor01" class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Bureau de change à Paris: où trouver le meilleur taux?</h1>
        <widget-author class="mb-6 mt-3">
          <div class="portrait">
            <span class="image" style="background-image:url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200');"></span>
            <p class="name pt-sm-2"><span>Écrit par</span><a href="https://www.monito.com/en/wiki/francois-briod?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content">François Briod</a></p>
            <p class="pb-sm-3 update"><span>Mis à jour</span>29 mai 2019</p>
          </div>
          <p class="bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti">Co-fondateur et PDG de Monito, et possède plus de six années d’expérience dans la FinTech et le secteur des Transferts d’Argent.</p>
        </widget-author>

        <p class="f_body">Vous êtes de visite à Paris ou dans les derniers préparatifs d’une escapade à l’étranger ? Qu’on vienne d’arriver dans la ville ou qu’on soit sur le départ, la question du change de devise revient régulièrement !</p>

        <div id="anchor02" ref="anchor02" class="f_body tips"><span style="text-align: center; display: block; margin: 0;">Notre recommandation : <b>optez pour une carte mutli-devises. </b></span><br/>Les cartes multi-devises permettent de payer à l'étranger et retirer des devises étrangères à des meilleurs taux que les bureaux de change. Il est aussi possible d'acheter des devises en ligne meilleur marché.

        <div class="cta">
          <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Utilisez notre outil de comparaison de cartes</a>
        </div>
      </div>
    
        <h2 class="f_subtitle_1">Trouver le meilleur bureau de change : une histoire de devise</h2>
        <p class="f_body">Trouver le meilleur bureau de change veut souvent dire trouver celui qui offre le meilleur taux. Si vous allez aux Etats Unis par exemple, vous pourrez y échanger vos euros contre des dollars. L’affaire pourrait être simple mais les choses se corsent lorsqu’on comprend que chaque bureau de change applique des taux de changes différents et donc des commissions différentes. En effet, il est rare qu’ils s’alignent sur le taux moyen du marché (celui qu’on trouve sur Google par exemple).</p>
        <p class="f_body">Ajoutons à cela que les devises changent de valeurs tous les jours - 1 euro peut valoir 0,97 dollar et passer à 0,90 dollar le lendemain !  Le taux de change de devise évolue donc en permanence.</p>
        <h3 class="f_subtitle_1">Le bureau de change sans commission existe-t-il ?</h3>
        <p class="f_body">Nombreux sont les établissements bancaires qui proclament fièrement faire des offres sans commissions. Néanmoins, restez vigilant ! S’ils n’appliquent peut-être pas de frais supplémentaires, cela ne les empêche pas d’échanger vos devises à un taux moins favorable que celui avec lequelles ils se fournissent, la différence restant dans leur poche. Vous vous êtes jamais demandé pourquoi les bureaux de changes pouvaient se permettre des vitrines dans des quartiers passants ou touristiques? Il n’y a pas de miracles, le bureau de change sans commission n’existe pas.</p>
      </section>
      <section class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
        <div class="color"></div>
        <h2 id="anchor03" ref="anchor03" class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Comment lire un tableau de change ?</h2>
        <p class="f_chapo">Si vous avez déjà observé un tableau de change, vous avez peut-être constaté qu’ils semblent bien compliqué à interpréter quand on ne sait pas comment les lire.</p>

        <img class="mt-6 mt-6-sm" src="https://images.prismic.io/monito/279c402d7ec422b749bd3724fe6509b858d7e00a_mvimg_20190603_154344.jpg?auto=compress,format" />
            
        <p class="f_body">Vous devez tout d’abord savoir si vous comptez acheter ou vendre une devise. En règle générale :</p>

        <ul class="f_body">
          <li>si vous êtes en France et que vous voulez échanger vos euros contre une monnaie étrangère, on dira que vous achetez une devise.</li>
          <li>si vous vous êtes en France mais que vous voulez avoir des euros contre des dollars, parce que vous revenez de voyage par exemple, alors vous serez en train de vendre des  devises.</li>
        </ul>
      <p class="f_body">Mais l’histoire ne s’arrête pas là, ça serait trop simple. Il faut se mettre à la place du bureau de change pour lire le tableau. Si vous achetez des devises, c’est que le bureau vous les vends. Si vous achetez des dollars contre des euros, le bureau de change vous vends des devises étrangères contre des euros, il faut donc regarder le taux de vente.</p>

      <h3 class="f_subtitle_1">Où trouver un bureau de change à Paris ?</h3>
      <p class="f_body">Imaginez-vous flâner dans les rues de Paris quand vous vient l’envie pressante de trouver un bureau de change à Montparnasse. Certes, vous aurez peut-être peu d’occasion de vouloir vous rendre dans un bureau de change sur un coup de tête, mais savoir où se trouvent les principaux établissements de la capitale vous aidera à anticiper vos échanges de devise.</p>
        
    </section>

    <section class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
        <div class="color"></div>
         <h2 id="anchor04" ref="anchor04" class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">Les principales agences de bureau de change à Paris</h2>
         <p class="f_body">Dans Paris, vous pouvez trouver des bureaux de changes dans les agences suivantes :</p>

         <table class="table">
          <thead>
            <tr>
              <th><p>Nom</p></th><th><p>Adresse</p></th><th><p>Numéro de téléphone</p></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>Travelex Paris</b></td><td><p>125, av des Champs-Elysées PARIS 75008</p></td><td><p>01 47 20 25 14</p></td>
            </tr>
            <tr><td><b>Change de la Bourse</b></td><td><p>28 rue Vivienne, 75002 Paris</p></td><td><p>01 40 28 11 11</p></td></tr>
            <tr><td><b>Comptoir Change Opéra</b></td><td><p>9 Rue Scribe, 75009 Paris</p></td><td><p>01 47 42 20 96</p></td></tr>
            <tr><td><b>CEN Change Dollar </b></td><td><p>70 Boulevard de Strasbourg, 75010 Paris</p></td><td><p>01 40 05 07 11</p></td></tr>
            <tr><td><b>Change Magenta</b></td><td><p>77 Boulevard de Magenta, 75010 Paris</p></td><td><p>01 42 46 56 93</p></td></tr>
          </tbody>
        </table>

        <h2  id="anchor05" ref="anchor05" class="f_subtitle_1">Comment comparer les taux de change et trouver le meilleur?</h2>
        <p class="f_body">Il suffit de poser la question à chaque bureau et comparer avec le vrai taux de change du marché que l'on trouve sur des sites comme <a target="_blank" rel="noopener" href="https://www.google.fr/search?q=500+usd+en+euros&amp;oq=500+usd+en+euros">Google</a>, <a href="https://www.xe.com/currencyconverter/convert/?Amount=500&amp;From=USD&amp;To=EUR">XE.com</a> ou <a target="_blank" rel="noopener" href="https://www.monito.com/meilleurs-taux-change/usd/eur">Monito</a>. Vu que ça peut prendre un peu de temps, on a voulu vous faciliter la tâche chez Monito et nous avons fait une comparaison pour vous. Voici la question que nous avons posé à 5 bureaux de change Parisiens:</p><p class="f_chapo">“Bonjour, je pars aux États-Unis la semaine prochaine, j'aimerai acheter 500 dollars, combien est-ce que cela me coûtera en Euros?“</p><p class="f_body">De même, nous avons demandé à Google ce que 500 dollars coûtent en euros pour comparer.</p>
        <table class="table"><thead><tr><th><p>Nom</p></th><th><p>Coût de 500 US Dollars en Euros</p></th><th><p>Commissions Cachée (%)</p></th><th><p>Commissions Cachée (€)</p></th></tr></thead> <tbody>
          <tr><td><b>Taux sur Google</b></td><td><p>442.78€</p></td><td><p>0%</p></td><td><p>0€</p></td></tr>
          <tr><td><b>Travelex Champs Élysées</b></td><td><p>531€</p></td><td><p>16.6%</p></td><td><p>88.22€</p></td></tr>
          <tr><td><b>Comptoir Change Opéra</b></td><td><p>470€</p></td><td><p>5.79%</p></td><td><p>27.22€</p></td></tr>
          <tr><td><b>Multi Change</b></td><td><p>467€</p></td><td><p>5.25%</p></td><td><p>24.52€</p></td></tr>
          <tr><td><b>Change de la Bourse</b></td><td><p>453€</p></td><td><p>2.32%</p></td><td><p>10.52€</p></td></tr>
          <tr><td><b>CEN Change Dollar </b></td><td><p>452.50€</p></td><td><p>2.15%</p></td><td><p>9.71€</p></td></tr>
        </tbody></table>
        <label class="ls-1 mb-2-sm fw-demi-bold f6">Comparaison de taux de change de bureaux Parisiens - 06.06.19</label>


        <h2  id="anchor06" ref="anchor06" class="f_subtitle_1">Verdict?</h2>
        <p class="f_chapo"><b>CEN Change Dollar</b> offre le meilleur taux pour acheter 500$ dans un bureau de change à Paris, mais cela reste une opération qui coûte pas loin de 10€, ce qui représentera plusieurs burgers lors de mon futur voyage aux USA.</p>
        <p class="f_body"><b>Travelex Champs Élysées</b> de son côté offre les services de change les plus onéreux. C'est 16% des 531€ payés à Travelex qui iront directement dans leur poche, avant qu'ils vous rendent 500$. Choqué, nous avons rappelé après avoir fait la comparaison pour s'assurer qu'il ne s'agissait pas d'une erreur et la personne au téléphone nous a confirmé les chiffrs et a ajouté que le taux sur Google n'était "accessible que pour les banquiers de Wall Street". Ce qui est complétement faux, comme vous allez le découvrir.</p>
        <p class="f_body">On constate également que <a href="https://www.monito.com/fr/wiki/achats-de-devises-en-ligne-ou-trouver-le-meilleur-taux">Travelex en ligne</a> prend néanmoins moins de commission que&nbsp; les agences Travelex physiques (5.7% de commissions en ligne vs 15-20% dans les agences de Lyon ou Paris <a href="https://admin.monito.com/fr/wiki/bureau-de-change-a-paris-ou-trouver-le-meilleur-taux"> </a>pour le même échange)!</p>

        <p class="f_body">De manière générale, la conversion des devises en agence peut vite coûter très cher comme l'a démontré notre comparaison. Au lieu d’acheter des billets en devises étrangères avant votre prochain voyage, pensez à commander une carte multi-devise comme les offres proposées par <a target="_blank" rel="noopener" href="https://go.monito.com/N26">N26</a>, <a target="_blank" rel="noopener" href="https://go.monito.com/monese">Monese</a>, <a target="_blank" rel="noopener" href="https://www.monito.com/fr/wiki/carte-bancaire-transferwise-pourquoi-nous-ladorons">TransferWise </a>ou <a target="_blank" rel="noopener" href="https://www.monito.com/fr/transferer-avec/revolut">Revolut</a>. Ces dernières permettent d’effectuer des retraits ou des paiement en devise étrangère avec le taux du marché et des commissions bien plus faibles que les bureaux de changes à Paris ou ailleurs ! Leur fonctionnement est très simple, il suffit d'alimenter la carte pré-payée avec un transfert bancaire ou sa carte bleue en Euro, et ensuite on peut payer et retirer de l'argent lors de sont voyage à moindre frais.</p>

        <p class="f_body">Découvrez <a href="https://www.monito.com/fr/wiki/comparatif-cartes-bancaires-sans-frais-a-l-etranger">notre comparatif des meilleures cartes bancaires à utiliser à l'étranger.</a></p>

        <h3 class="f_subtitle_2">Pas le temps d’aller dans un bureau de change à Paris ? Découvrez la livraison !</h3>

        <p class="f_chapo">Dans certains cas, il est possible d’accéder à des services de livraison à domicile. Bien pratique si vous ne pouvez pas vous déplacer en agence pour récupérer vos devises !</p>

        <p class="f_body">Il suffit d’acheter vos devises en ligne sur un site comme celui de <a href="https://www.ccopera.com/">Comptoir Change Opéra.</a> Dans les 24h à 72h ouvrés, vous recevrez vos devises dans une emballage cartonné, sécurisé et neutre dont le format répond aux normes en vigueur. </p>

        <p class="f_body">Cette option est disponible pour tout achat de valeur à partir de 300 euros et le service de livraison coûte 21 euros.</p>




    </section>
    
  </section>
    
    <aside ref="scroll_widgets" class="scroller article_content">
      <div class="aside_widget">
        <h4 class="fw-demi-bold fs-16 pt-4 pb-1 ">Un petit saut dans l'article ?</h4>
        <ul class="fw-demi-bold f-anti fs-16 pb-3">
          <li class="active" @click="anchor01()">Introduction</li>
          <li @click="anchor02()">Notre recommandation <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta hide fw-bold f-anti f-19 ls-1">Comparer les cartes <br/>mutli-devices</a></li>
          <li @click="anchor03()">Comment lire un tableau de change ?</li>
          <li @click="anchor04()">Les principales agences de bureau de change à Paris</li>
          <li @click="anchor05()">Comment comparer les taux de change et trouver le meilleur?</li>
          <li @click="anchor06()">Verdict</li>
        </ul>
      </div>
    </aside>
   
  </main>
    
  <widget-faq>
      <ul class="shadow">
        <li>
          <h3>Which company offers a bank account in the UK if I don't have the proof of address? 🏦</h3>
          <p class="f_body">There are few companies that offer a bank account in the UK, even when you don't have a proof of address in the UK. With Monzo or Monese, you can open a UK bank account with just a few clicks. All the details about <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">opening a bank account in the UK without the proof of address</a>, you will find in our blog post. </p>
        </li>
        <li>
          <h3>What is the best UK bank accout for non residents?</h3>
          <p class="f_body">Expats moving to the UK 🇬🇧might find it difficult to open a traditional bank account. To open a bank account, you need a proof of address, which might be hard to get if you are a non-resident. Good news is that companies liked Monzo or Monese offer a UK bank account without proof of address. You can have a UK bank account with just a few clicks. <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">More info about UK bank account for non-residents you will find in our blog post</a>.</p>
        </li>
        <li>
          <h3>Is it possible to have Euro bank account in the UK? 💶</h3>
          <p class="f_body">Some UK banks offer bank account in Euro. However, the fees for such accounts are quite high. But we have good news - there is a possibility to open a bank account in Euro for free. Check out our <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">blog post about opening a bank account in the UK without proof of address</a> and get a free UK bank account in Euro. </p>
        </li>
        <li>
          <h3>What documents do I need to open a bank account in the UK? 📄  </h3>
          <p class="f_body">To open a UK bank account, you generally need two things:<br>1️. Proof of your identity - passport, drivers license, or national identity card. In general, if you are a foreign national, your best bet is to use your passport.<br>2. Proof of the address in the UK. It can be a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted. <br><br>If you don't have a proof of address, have a look at our <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">blog post about opening a bank account in the UK</a>. </p>
        </li>
        <li>
          <h3>Can a foreigner open a bank account in the UK? 🇬🇧</h3>
          <p class="f_body">Foreigners can open a traditional bank account in the UK as long as they have proof of the address, which sometimes it's hard to get. Good news is that there are companies like Monzo or Monese which offer UK bank account even without the proof of the address. All the information about <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">opening a bank account in the UK you will find in our blog post</a>. </p>
        </li>
      </ul>
  </widget-faq>
  <widget-articles :articles="articles"><h1 class="fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4">This might interest you too</h1></widget-articles>
  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
  	data() {
  		return {
  			herotype :'contentpage',
        scrollingActive : true,
        anchor : '01',
        urlBackground :'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
        providers : [
          {logo: 'public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: 'public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: 'public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: 'public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: 'public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: 'public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
            url:'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best way for freelancers to get paid',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in the U.S. without proof of residency',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
            url:'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'Digital Nomads — Getting Your Finances Right',
            date_author:'Feb. 28, 2020  -  by François Briod'},
          
          
          { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in Australia without proof of residency',
            date_author:'Jan. 20, 2020  -  by François Briod'},
          
          { cover: '',
            url:'https://www.monito.com/en/wiki/living-in-france',
            title:'Living in France',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
            title:'How to open a bank account in Canada without proof of residency',
            date_author:'Jul. 17, 2019  -  by François Briod'}
          
         

        ]
  		}
  	},
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      anchor02 = this.$refs.anchor02.getBoundingClientRect(),
      anchor03 = this.$refs.anchor03.getBoundingClientRect(),
      anchor04 = this.$refs.anchor04.getBoundingClientRect(),
      anchor05 = this.$refs.anchor05.getBoundingClientRect(),
      anchor06 = this.$refs.anchor06.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,
      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.scroll_zone.clientHeight,
     

    
      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);
      var windows_width = window.innerWidth;


      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if(windows_width > 980){
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }


        if (this.scrollingActive == true){
            if(y > (position_x_aside - 20 + 232)){
              if(y <= (bottom_main_content - aside_height - 20)){
                this.$refs.scroll_widgets.style.position = 'fixed';
                this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
                this.$refs.scroll_widgets.style.top = 20 + 'px';
              } else {
                this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
                this.$refs.scroll_widgets.style.position = 'absolute';
                this.$refs.scroll_widgets.style.left = '';
              }
            } else {
              this.$refs.scroll_widgets.style.top = '232px';
              this.$refs.scroll_widgets.style.position = 'absolute';
              this.$refs.scroll_widgets.style.left = '';
            }
        } else {
              this.$refs.scroll_widgets.style.position = 'relative';
              this.$refs.scroll_widgets.style.left = '';
              this.$refs.scroll_widgets.style.top = '';
        }

        if(anchor02.top < 190 && anchor03.top > 190) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(2)").addClass('active');
           
        } else if(anchor03.top < 200 && anchor04.top > 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(3)").addClass('active');
        } else if(anchor04.top < 200 && anchor05.top > 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(4)").addClass('active');
        } else if(anchor05.top < 200 && anchor06.top > 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(5)").addClass('active');
        } else if(anchor06.top < 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(6)").addClass('active');
        } else {
           $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(1)").addClass('active');
        }

        if(anchor02.bottom < 0){
         $(".article_content ul li a.btn_cta").removeClass('hide');
         $(".article_content ul li a.btn_cta").addClass('anime');
         
        } else {
          $(".article_content ul li a.btn_cta").addClass('hide');
        }  
      },
      anchor01(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor01").offset().top - 40
        }, 1000);

      },
      anchor02(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor02").offset().top - 142
        }, 1000);
       
      },
      anchor03(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor03").offset().top - 80
        }, 1000);
      },
      anchor04(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor04").offset().top - 80
        }, 1000);
      },
      anchor05(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor05").offset().top - 80
        }, 1000);
      },
      anchor06(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor06").offset().top - 80
        }, 1000);
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">

  main {
    position: relative;
    z-index: 10000;
    margin-top: -290px;


    @media ($tablet_portrait) {
        margin-top: -170px;
    }
    @media ($mobile) {
        margin-top: -150px;
    }
  }



  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 232px;
  }

  .scroller.article_content {
    top: 232px;

    .aside_widget {
      padding: 0;
    }

    h4 {
      color: #676767;
    }
  }

  .article_content ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;

    li {
      padding: 12px 50px;
      color: #353C45; 
      cursor: pointer;
      transition: all 0.2s ease;

      a {
        background: #0CC3CA;
        text-align: center;
        

        &:hover {
          background: #17d5dc;
        }

        &.hide {
          display: none!important;
        }

        &.anime {
          animation-name: apparition_btn_cta;
          animation-duration: 1s;
          position: relative;

          @keyframes apparition_btn_cta {
            from {bottom: -10px; opacity: 0;}
            to {bottom: 0; opacity: 1;}
          }
        }
      }

      &:hover {
        background: #D3F5F560;
      }


      &.active {
        background: #D3F5F5;
        color: #004660;
        position: relative;
        padding-top: 24px;
        padding-bottom: 24px;
        cursor: default;

        &:after {
          content: '';
          width: 0;
          height: 0;
          border-top: 35px solid transparent;
          border-bottom: 37px solid transparent;
          border-right: 14px solid #D3F5F5;
          left: -14px;
          top: calc(50% - 35px);
          position: absolute;
        }  
      }
    }
  }

  @media ($tablet_portrait) {
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      h1 {
        text-align: center;
      }
    }

    .scroller {
      width: 90%;
      margin-left: 5%;
      position: relative!important;
      top: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/BureauChange.vue